<div class="flex-container" style="height: 100%">
  <vl-widget-title
    [text]="'stats.ca_cumule' | trans"
    [accent]="totalDisplay()"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ "button.filter" | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover filtres -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <div class="caption on-background">Options d'affichage</div>
      <vl-chips-toggle
        [(value)]="timeScale"
        [elements]="timeScaleChoices"
      ></vl-chips-toggle>
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
              height: '200px',
              'background-color': 'var(--color-on-disabled)',
            }"
      />
    </div>
  } @else {
    <div class="h100 fade-in" style="width:100%;">
      <canvas #c style="width:100%; height:100%; display:block;"></canvas>
    </div>

    @if (!points().length) {
      <div class="widget-content empty">
        <div class="caption on-disabled">
          {{ 'filters.no_data' | trans }}
        </div>
      </div>
    }
  }
</div>
